import axios from 'axios'
import { attachLoading } from './loading'

const defaultAxios = axios.create({
  baseURL: '/',
});

// 전역 로딩 인터셉터
attachLoading(defaultAxios);

export default defaultAxios;